import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import Util from '../../script/util';
import HTTP from '../../script/service';
import LegalRights from '../legalRights';
import { message } from 'antd';
import { _get_user_is_black_room, _link_kf } from '../../store/Action';
import * as Map from 'immutable';
import CancelOrder from '../center/myorders/CancelOrder';
import CreateGameRoom from '../createGameRoom';

class TopOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  //验证是否更新
  shouldComponentUpdate(newProps, newState) {
    const props1 = Map.fromJS(newProps.order);
    const props2 = Map.fromJS(this.props.order);
    const bool = Map.is(props1, props2);
    if (!bool) {
      return true;
    } else {
      return false;
    }
  }

  changeOrderState = (order, n) => {
    HTTP._modified_order({
      uid: this.props.base.uid,
      orderId: order.orderId,
      orderStatus: n,
    }).then((res) => {
      if (res?.code === 200) {
        this.props.changeOrder();
      } else {
        message.error(res?.message || '操作失败，请稍后重试哦~');
      }
    });
  };
  // 创建开黑房
  createRoom = (order, n) => {
    if (n === 4) {
      const { base } = this.props;
      if (base?.uid) {
        let isOk = false;
        if (base?.isBlackRoom == null) {
          _get_user_is_black_room(base.uid, (bool) => {
            isOk = bool;
          });
        } else {
          isOk = !!base.isBlackRoom;
        }

        if (isOk) {
          this.createRoomElement.showModal(null, order.playUid);
        } else {
          message.warning('您暂时没有创建开黑房的权限');
        }
      }
    }
  };
  //维权
  onLegalRights = () => {
    //我是买家
    if (this.props.base.uid == this.props.order.playUid) {
      if (this.props.order.orderStatus === 8) {
        this.legalRightsElement.showModal(this.props.order, 'play');
      } else {
        message.warning('你已提交过维权申请，无需再次提交。');
      }
    }
    //我是大神
    else if (this.props.base.uid == this.props.order.godUid) {
      if (this.props.order.appealStatus !== 2) {
        this.legalRightsElement.showModal(this.props.order, 'god');
      } else {
        message.warning('你已提交过维权申请，无需再次提交。');
      }
    }
  };
  //取消订单
  cancelOrder = (item) => {
    this.cancelElement.showModal({
      uid: this.props.base.uid,
      orderId: item.orderId,
      cancelType: 15,
    });
  };
  //拒绝接单
  cancelOrder1 = (item) => {
    this.cancelElement.showModal({
      uid: this.props.base.uid,
      orderId: item.orderId,
      cancelType: 16,
    });
  };
  //申请退款
  cancelOrder2 = (item) => {
    this.cancelElement.showModal({
      uid: this.props.base.uid,
      orderId: item.orderId,
      cancelType: 17,
    });
  };
  //拒绝退款
  cancelOrder3 = (item) => {
    this.cancelElement.showModal({
      uid: this.props.base.uid,
      orderId: item.orderId,
      cancelType: 18,
    });
  };
  diamondPrice = (price) => {
    return (
      <div className="d-price">
        {price * 100}
        <span className="d-icon"></span>
      </div>
    );
  };

  render() {
    const { order, base } = this.props;
    //获取订单状态
    const getOrderStatus = () => {
      let stateDom = null;
      const { orderStatus, appealStatus } = order;
      if (order.playUid == base.uid) {
        if (orderStatus === -1) {
          stateDom = <p className="rr1 gray">已过期</p>;
        } else if (orderStatus === 1) {
          stateDom = <p className="rr1 warn">待支付</p>;
        } else if (orderStatus === 2) {
          stateDom = (
            <span>
              <p className="warn">待接单</p>
              <p>待大神确认接单</p>
            </span>
          );
        } else if (orderStatus === 3) {
          stateDom = (
            <span>
              <p className="cyan">待服务</p>
              <p>待大神开始服务</p>
            </span>
          );
        } else if (orderStatus === 4) {
          stateDom = <p className="rr1 reading">服务中</p>;
        } else if (orderStatus === 5) {
          stateDom = <p className="rr1 green">已完成</p>;
        } else if (orderStatus === 6) {
          stateDom = (
            <span>
              <p className="red">退款中</p>
              <p>待大神同意退款</p>
            </span>
          );
        } else if (orderStatus === 7) {
          stateDom = (
            <span>
              <p className="green">已退款</p>
              <p>大神已同意退款</p>
            </span>
          );
        } else if (orderStatus === 8) {
          stateDom = (
            <span>
              <p className="red">退款中</p>
              <p>大神拒绝退款</p>
            </span>
          );
        } else if (orderStatus === 9) {
          stateDom = (
            <span>
              <p className="warn">维权中</p>
              <p>等待客服裁决</p>
            </span>
          );
        } else if (orderStatus === 10) {
          stateDom = <p className="rr1 red">维权失败</p>;
        } else if (orderStatus === 11) {
          stateDom = (
            <span>
              <p className="warn">维权成功</p>
              <p>系统已自动退款</p>
            </span>
          );
        } else if (orderStatus === 14) {
          stateDom = (
            <span>
              <p className="warn">退款中</p>
              <p>等待系统自动退款</p>
            </span>
          );
        } else if (orderStatus === 12) {
          stateDom = (
            <span>
              <p className="red">退款失败</p>
              <p>异常情况请联系客服</p>
            </span>
          );
        } else if (orderStatus === 13) {
          stateDom = (
            <span>
              <p className="red">退款失败</p>
              <p>未在规定时间内提交维权信息</p>
            </span>
          );
        }
      } else {
        if (orderStatus === -1) {
          stateDom = <p className="rr1 gray">已过期</p>;
        } else if (orderStatus === 0) {
          stateDom = <p className="rr1 gray">已取消</p>;
        } else if (orderStatus === 2) {
          stateDom = <p className="rr1 warn">待接单</p>;
        } else if (orderStatus === 3) {
          stateDom = <p className="rr1 warn">待服务</p>;
        } else if (orderStatus === 4) {
          stateDom = <p className="rr1 warn">服务中</p>;
        } else if (orderStatus === 5) {
          stateDom = <p className="rr1 warn">已完成</p>;
        } else if (orderStatus === 6 || orderStatus === 14) {
          stateDom = <p className="rr1 warn">退款中</p>;
        } else if (orderStatus === 7 || orderStatus === 11) {
          stateDom = <p className="rr1 green">已退款</p>;
        } else if (orderStatus === 8) {
          stateDom = (
            <span>
              <p className="red">退款中</p>
              <p>已拒绝退款申请</p>
            </span>
          );
        } else if (orderStatus === 9) {
          if (appealStatus != 2) {
            stateDom = (
              <span>
                <p className="warn">维权中</p>
                <p>请提交维权资料</p>
              </span>
            );
          } else {
            stateDom = (
              <span>
                <p className="warn">维权中</p>
                <p>等待客服裁决</p>
              </span>
            );
          }
        } else if (
          orderStatus === 10 ||
          orderStatus === 12 ||
          orderStatus === 13
        ) {
          stateDom = <p className="rr1 green">已完成</p>;
        }
      }
      return stateDom;
    };
    //获取订单操作
    const getOrderAction = () => {
      let action = null;
      const { orderStatus } = order;
      if (order.playUid == base.uid) {
        if (
          orderStatus === -1 ||
          orderStatus === 0 ||
          orderStatus === 1 ||
          orderStatus === 3 ||
          orderStatus === 6 ||
          orderStatus === 7 ||
          orderStatus === 10 ||
          orderStatus === 11 ||
          orderStatus === 13 ||
          orderStatus === 14
        ) {
          action = null;
        } else if (orderStatus === 2) {
          action = (
            <span>
              <button
                className="daidai-btn-blank"
                onClick={this.cancelOrder.bind(this, order)}
              >
                取消订单
              </button>
            </span>
          );
        } else if (orderStatus === 4) {
          action = (
            <span>
              <button
                className="daidai-btn-blank"
                onClick={this.cancelOrder2.bind(this, order)}
              >
                申请退款
              </button>
              <button
                className="daidai-btn-primary"
                onClick={this.changeOrderState.bind(this, order, 5)}
              >
                完成服务
              </button>
            </span>
          );
        } else if (orderStatus === 5) {
          action = (
            <span>
              <button className="daidai-btn-blank">再次下单</button>
              <button className="daidai-btn-primary">评价</button>
            </span>
          );
        } else if (orderStatus === 8) {
          action = (
            <button className="daidai-btn-primary" onClick={this.onLegalRights}>
              申请维权
            </button>
          );
        } else if (orderStatus === 12) {
          action = (
            <span>
              <button className="daidai-btn-primary" onClick={() => _link_kf()}>
                联系客服
              </button>
            </span>
          );
        }
      } else {
        if (
          orderStatus === -1 ||
          orderStatus === 0 ||
          orderStatus === 1 ||
          orderStatus === 7 ||
          orderStatus === 8 ||
          orderStatus === 10 ||
          orderStatus === 11 ||
          orderStatus === 13 ||
          orderStatus === 14
        ) {
          action = null;
        } else if (orderStatus === 2) {
          action = (
            <span>
              <button
                className="daidai-btn-primary"
                onClick={this.changeOrderState.bind(this, order, 3)}
              >
                接单
              </button>
              <button
                className="daidai-btn-blank"
                onClick={this.cancelOrder1.bind(this, order)}
              >
                拒绝接单
              </button>
            </span>
          );
        } else if (orderStatus === 3) {
          action = (
            <button
              className="daidai-btn-primary"
              onClick={this.changeOrderState.bind(this, order, 4)}
            >
              开始服务
            </button>
          );
        } else if (orderStatus === 4) {
          action = (
            <button
              className="daidai-btn-primary"
              onClick={this.createRoom.bind(this, order, 4)}
            >
              邀请Ta一起开黑
            </button>
          );
        } else if (orderStatus === 5) {
          action = <button className="daidai-btn-primary">查看评价</button>;
        } else if (orderStatus === 6) {
          action = (
            <span>
              <button
                className="daidai-btn-blank"
                onClick={this.changeOrderState.bind(this, order, 7)}
              >
                同意退款
              </button>
              <button
                className="daidai-btn-primary"
                onClick={this.cancelOrder3.bind(this, order)}
              >
                拒绝退款
              </button>
            </span>
          );
        } else if (orderStatus === 9 && order.appealStatus !== 2) {
          action = (
            <button className="daidai-btn-primary" onClick={this.onLegalRights}>
              申请维权
            </button>
          );
        } else if (orderStatus === 12) {
          action = (
            <button className="daidai-btn-primary" onClick={() => _link_kf()}>
              联系客服
            </button>
          );
        }
      }
      return action;
    };
    return (
      <div className="top-p2p-order">
        {order ? (
          <div className="border-plan fadeInDown animated faster">
            <div className="order-bg">
              <div className="c-cover">
                <img
                  alt=""
                  src={Util.transImgUrl(
                    order.categoryInfo ? order.categoryInfo.icon : null
                  )}
                />
              </div>
              <span className="c-name">{order.categoryName}</span>
              <div className="c-price">
                {base.rootConfig.lang == 'zh_CN' && (
                  <span className="p1">
                    ￥{order.price}/{order.unit}
                  </span>
                )}
                {base.rootConfig.lang != 'zh_CN' && (
                  <span className="p1">
                    {order.price * 100}钻/{order.unit}
                  </span>
                )}
                <span className="p2">x{order.num}</span>
                {base.uid == order.playUid ? (
                  <span className="p3">
                    {base.rootConfig.lang == 'zh_CN'
                      ? '￥' + order.payAmount
                      : this.diamondPrice(order.payAmount)}
                  </span>
                ) : (
                  <span className="p3">
                    {base.rootConfig.lang == 'zh_CN'
                      ? '￥' + order.orderAmount
                      : this.diamondPrice(order.orderAmount)}
                  </span>
                )}
              </div>
              <div className="c-status">{getOrderStatus()}</div>
              <div className="c-action">{getOrderAction()}</div>
            </div>
          </div>
        ) : null}
        <LegalRights
          ref={(el) => (this.legalRightsElement = el)}
          uid={base.uid}
          changeOrder={this.props.changeOrder}
        />
        {/* 取消订单 */}
        <CancelOrder
          wrappedComponentRef={(el) => (this.cancelElement = el)}
          reload={this.props.changeOrder}
        />
        {/* 创建房间 */}
        <CreateGameRoom
          wrappedComponentRef={(el) => (this.createRoomElement = el)}
          base={this.props.base}
        />
      </div>
    );
  }
}

export default withRouter(TopOrder, { withRef: true });
